import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import MarkEmailReadRoundedIcon from '@mui/icons-material/MarkEmailReadRounded';
import { Link as RouterLink } from 'react-router-dom';
import { getApiUrl } from '../utils/api';

const API_URL = getApiUrl();
const SUCCESS_MESSAGE = 'Se o e-mail estiver cadastrado, enviaremos um link para redefinir sua senha.';

const RecuperarSenha = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSent(false);
    setSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(data.error || 'Falha ao solicitar recuperação.');
      }
      setSent(true);
    } catch (err) {
      setError(err.message || 'Falha ao solicitar recuperação.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        background: 'radial-gradient(circle at top, #f59e0b 0%, #f97316 26%, #111827 100%)',
      }}
    >
      <Card
        sx={{
          width: '100%',
          maxWidth: 480,
          borderRadius: 4,
          boxShadow: '0 32px 80px rgba(15, 23, 42, 0.28)',
        }}
      >
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            <Stack spacing={1}>
              <Box
                sx={{
                  width: 56,
                  height: 56,
                  borderRadius: 3,
                  bgcolor: '#111827',
                  color: '#fff',
                  display: 'grid',
                  placeItems: 'center',
                }}
              >
                <MarkEmailReadRoundedIcon />
              </Box>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#111827' }}>
                Recuperar senha
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Informe o e-mail cadastrado no Brutos Delivery para receber o link de redefinição.
              </Typography>
            </Stack>

            <Box component="form" onSubmit={handleSubmit}>
              <Stack spacing={2}>
                {sent ? <Alert severity="success">{SUCCESS_MESSAGE}</Alert> : null}
                {error ? <Alert severity="error">{error}</Alert> : null}
                <TextField
                  label="E-mail"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="email"
                  type="email"
                  fullWidth
                  required
                />
                <Button type="submit" size="large" variant="contained" disabled={submitting}>
                  {submitting ? 'Enviando...' : 'Enviar link'}
                </Button>
                <Button component={RouterLink} to="/login" variant="text" size="small">
                  Voltar para login
                </Button>
              </Stack>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

export default RecuperarSenha;
